import { lazy } from "react";
// Public components
const Presale = lazy(() => import("../Pages/Presale/Presale"));
const Staking = lazy(() => import("../Pages/Staking/Staking"));

export const publicRoutes = [
  { path: "/presale", element: <Presale /> },
  { path: "/staking", element: <Staking /> },
];
